<script>
  export default {
    name: 'screen-group-edit-modal',

    data () {
      return {
        group: {}
      }
    },

    methods: {
      handleOk (e) {
        e.preventDefault()

        this.$store.dispatch('screenGroups/editGroup', this.group).then(() => {
          this.$refs.modal.hide()
          this.group = {}
        }).catch((err) => {
          console.log('Unable to save screen group', err)
        })
      }
    },

    created () {
      this.$emit('update:title', 'Edit Screen Group')
      this.$emit('update:ok-title', 'Save & Continue')
    }
  }
</script>

<template>
  <b-card-body>
  </b-card-body>
</template>
